export default "__VITE_ASSET__df2deae9__"